import { TokenAutorizacao } from "./MinhaAcaoPermissao.model";

// Credenciais digitadas no modal (as mesmas do login, sem o e-mail: a conta é a do usuário logado)
export interface CredenciaisAutorizacao {
    password: string;
    user?: string;
    asAdministrator?: boolean;
}

export interface ResultadoAutorizacao {
    autorizacao?: TokenAutorizacao;
    erro?: string;
    // Regra 37: a API recusou por excesso de tentativas de senha; o modal não aceita mais tentativas
    tentativasEsgotadas?: boolean;
}

// Largura do modal "Autorizar acesso" e do pop-up de ajuda dele: os dois têm o mesmo tamanho
export const LARGURA_MODAL_AUTORIZAR_ACESSO = '400px';

export interface DadosAprovarAcesso {
    // "Módulo / Tela - Funcionalidade" que abriu o modal (igual à grade do grupo de permissão); vazio se não houver texto
    funcionalidade?: string;
    // Valida as credenciais digitadas e diz se aquele usuário pode autorizar
    validar: (credenciais: CredenciaisAutorizacao) => Promise<ResultadoAutorizacao>;
}
